import React, { useState } from 'react';
import CategoryCard from "./sections/Cards";
import CategoryTable from "./sections/CategoryTable";
import AddCategoryModal from "./sections/modals/AddCategoryModal";
import ViewCategoryModal from "./sections/modals/ViewCategoryModal";
import EditCategoryModal from "./sections/modals/EditCategoryModal";
import { Category } from '@mui/icons-material';
import ConfirmModal from '@/components/UI/Modals/ConfirmModal';
import { useDeleteCategoryMutation } from '@/services/api/category/categoryApi';
import { message } from 'antd';


/**
 * Category Management Page
 * Displays category statistics and table with add functionality
 */
const CategoryPage = () => {
  const [isAddModalVisible, setIsAddModalVisible] = useState(false);
  const [isViewModalVisible, setIsViewModalVisible] = useState(false);
  const [isEditModalVisible, setIsEditModalVisible] = useState(false);
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [isDeleteModalVisible, setIsDeleteModalVisible] = useState(false);

  const [deleteCategory, { isLoading: isdeletingCat }] = useDeleteCategoryMutation();

  // Handle modal actions
  const handleAddCategory = () => {
    setIsAddModalVisible(true);
  };

  const handleCloseAddModal = () => {
    setIsAddModalVisible(false);
  };

  const handleAddSuccess = () => {
    // Category was created successfully, table will auto-refresh
    // console.log('Category created successfully');
  };

  const handleEditCategory = (record) => {
    setSelectedCategory(record);
    setIsEditModalVisible(true);
  };

  const handleCloseEditModal = () => {
    setIsEditModalVisible(false);
    setSelectedCategory(null);
  };

  const handleEditSuccess = () => {
    // Category was updated successfully, table will auto-refresh
    // console.log('Category updated successfully');
  };

  const handleViewCategory = (record) => {
    setSelectedCategory(record);
    setIsViewModalVisible(true);
  };

  const handleOpenDeleteModal = (record) => {
    setIsDeleteModalVisible(true);
    setSelectedCategory(record);
  }

  const handleCloseDeleteModal = () => {
    setIsDeleteModalVisible(false);
    setSelectedCategory(null);
  };

  const handleDeleteCategory = async () => {
    try {
      await deleteCategory(selectedCategory.id).unwrap();
      handleCloseDeleteModal();
    } catch (error) {
      // debugger
      message.error(error.data.message || 'Failed to delete category.');
    }
  }

  const handleCloseViewModal = () => {
    setIsViewModalVisible(false);
    setSelectedCategory(null);
  };

  return (
    <div className="min-h-screen bg-gray-50">
      <div className="container mx-auto py-8">
        <div className='flex flex-col gap-6'>
          {/* Category Statistics Cards */}
          <CategoryCard />

          {/* Category Table */}
          <CategoryTable
            onAddCategory={handleAddCategory}
            onEditCategory={handleEditCategory}
            onViewCategory={handleViewCategory}
            onDeleteCategory={handleOpenDeleteModal}
          />
        </div>
      </div>

      {/* Add Category Modal */}
      <AddCategoryModal
        visible={isAddModalVisible}
        onCancel={handleCloseAddModal}
        onSuccess={handleAddSuccess}
      />

      {/* View Category Modal */}
      <ViewCategoryModal
        visible={isViewModalVisible}
        onCancel={handleCloseViewModal}
        categoryData={selectedCategory}
      />

      {/* Edit Category Modal */}
      <EditCategoryModal
        visible={isEditModalVisible}
        onCancel={handleCloseEditModal}
        onSuccess={handleEditSuccess}
        categoryData={selectedCategory}
      />
      <ConfirmModal
        title="Delete Category"
        isOpen={isDeleteModalVisible}
        handleClose={handleCloseDeleteModal}
        onDelete={handleDeleteCategory}
        loading={isdeletingCat}
        content={<span>category <b style={{color:'black'}}>"{selectedCategory?.name}"</b></span>}
      />
    </div>
  );
};

export default CategoryPage;